<template>
  <div class="app-container">
    <div class="app-container-title">版权声明</div>
    <div class="list">
      <div class="title">中国国家图书馆网站版权声明</div>
      <p>您在使用中国国家图书馆·中国国家数字图书馆网站（下称“本网站”）各项产品及服务之前，请务必仔细阅读本声明。作为国家重要的公共文化服务机构，本网站严格按照《中华人民共和国民法典》《中华人民共和国公共图书馆法》《中华人民共和国著作权法》《信息网络传播权保护条例》及相关法律、法规、政策面向各界读者开展公益性文献信息服务，并积极采用技术措施保护各方合法权益。访问、浏览或使用本网站，表明您已阅读、理解并同意以下条款内容，并遵守所有适用的法律法规。如果您不同意以下任何条款，请停止浏览、使用本网站。</p>
      <div>一、著作权声明</div>
      <p>本网站发布的所有自建的或与他人共同开发的信息和内容，包括但不限于标识、图文、音频、视频、网站版式、网页设计等各项内容，除特别注明外，相关作品的著作权均为国家图书馆所有。任何单位或个人未经事先书面许可，均不得将以上内容用于任何商业用途，未经许可用于商业用途或非法目的而侵害我馆合法权益甚至影响我馆声誉的，我馆保留依法追究其法律责任的权利。如需使用相关资料，请提前与我馆相关部门联系（联系邮箱： webmaster@nlc.cn）。</p>
      <div>二、网站内容的使用和修改</div>
      <p>任何单位或个人在以转载、引用、摘编、下载等方式使用本网站内容时，均须注明作者，并标明内容的出处为“中国国家图书馆·中国国家数字图书馆网站”或“http://www.nlc.cn/”。未经国家图书馆或相关权利人的书面许可，不得修改所使用的内容，也不得进行侵犯或可能侵犯国家图书馆权益的数据采集、网络爬虫或类似的数据收集以及数据摘录等行为。</p>
      <div>三、侵权通知</div>
      <p>本网站可能有部分信息是从内容合作方、免费资源提供方转载、摘编获得的。如果您发现本网站使用了您拥有著作权的作品并对我们的编辑、服务方式有异议，或认为本网站存在侵犯您合法权益的内容，可依法向我馆（联系邮箱：webmaster@nlc.cn）发出书面通知，通知应包括您的身份证明及作品权利证明等有关文件，我们将根据相关法律规定及时妥善处理。</p>
      <div>四、不保证声明</div>
      <p>本网站力图提供准确的信息和内容，但我馆并不对本网站所载的信息和内容，包括但不限于图文、数据、观点、建议、网页等的准确性、完整性、充分性和可靠性作出保证，也不对所载信息和内容作出任何明示或默示的、包括但不限于有关权利、质量和没有计算机病毒的保证。</p>
      <div>五、第三方链接</div>
      <p>本网站为向用户提供便利设置了第三方链接并对其进行了必要的遴选，但不保证这些链接的准确性、完整性和安全性，也不对其承担任何责任，访问这些链接将由用户自己作出决定。本网站转载第三方链接内容均会注明来源，转载目的在于传递更多信息，但并不代表本网站及国家图书馆观点。</p>
      <p>为尽可能保证我馆购买或者正在试用的数据库、电子资源等无知识产权瑕疵，我们对资源供应方的资质和权利凭证进行了必要的形式审查且要求其保证资源产品不存在知识产权瑕疵。如有按规定使用此类资源导致侵犯第三方知识产权的，由资源供应方承担相应的责任。</p>
      <p>如发现有涉及侵权情况请及时联系我馆，我们将及时删除侵权链接并妥善处理。</p>
      <div>六、免责声明</div>
      <p>本网站及我馆不承担因您使用或不能使用本网站信息所导致的任何直接、间接或意外的损害责任，也不承担因您违反本网站规定或触犯中华人民共和国法律而引起的任何法律责任。</p>
      <p>本网站如因系统维护或升级而需暂停服务时，将事先公告。若因硬件故障或其它不可抗力而暂停服务，于暂停服务期间造成的一切不便与损失，本网站及我馆不承担任何责任。</p>
      <p>本声明之修改权和最终解释权均属国家图书馆所有。本网站如有疏漏错误之处，敬请及时告知，以便我馆采取适当方式予以改进。希望得到全体著作权人和出版单位的鼎力支持。</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import navigation from '../../components/navigation'


export default {
  name: 'copyright',
  components: {navigation},
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
  }
}
</script>

<style scoped>
.app-container{
  overflow-y:scroll;
  overflow-X:hidden;
  background:#ecf5fd;
  min-height: calc(100% - .92rem);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.app-container-title{
  width:100%;
  height:.92rem;
  background:#fff;
  text-align:center;
  line-height:.92rem;
  font-size:.32rem;
  font-weight: 500;
}

.list{
  width:6.1rem;
  margin:.26rem .28rem .34rem .28rem;
  padding:.44rem .42rem;
  background:#fff;
  border-radius:8px;
  font-size: .28rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.list div{
  font-weight:bold;
}
.title{
  text-align:center;
  font-size:.3rem;
  padding-bottom:.1rem;
}
p{
  margin:0;
  padding:0;
  text-indent: 2em;
  text-align:justify;
  text-justify:inter-ideograph;
}
h1{
  color:#444649;
  width:100%;
  text-align: center;
  word-wrap:break-word;
}
</style>



// WEBPACK FOOTER //
// src/view/copyright/index.vue